import { render, staticRenderFns } from "./TabbedContentSlide.vue?vue&type=template&id=87a74f16&scoped=true"
import script from "./TabbedContentSlide.vue?vue&type=script&lang=js"
export * from "./TabbedContentSlide.vue?vue&type=script&lang=js"
import style0 from "./TabbedContentSlide.vue?vue&type=style&index=0&id=87a74f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a74f16",
  null
  
)

export default component.exports